module.exports = __webpack_public_path__ + "img/wheel_replace.1aacf5a3.svg";